export const ADMIN_BASE_PATH = "/pulse-ops-x7k2" as const;

export function adminPath(subpath?: string): string {
  if (!subpath) return ADMIN_BASE_PATH;
  const normalized = subpath.startsWith("/") ? subpath.slice(1) : subpath;
  return `${ADMIN_BASE_PATH}/${normalized}`;
}

export function isAdminPath(pathname: string): boolean {
  return pathname === ADMIN_BASE_PATH || pathname.startsWith(`${ADMIN_BASE_PATH}/`);
}

export function isAdminPortalPath(pathname: string): boolean {
  if (isAdminPublicPath(pathname)) return false;
  return pathname.startsWith(`${ADMIN_BASE_PATH}/`) && pathname !== `${ADMIN_BASE_PATH}/`;
}

export function isAdminPublicPath(pathname: string): boolean {
  return (
    pathname === adminPath("recover") ||
    pathname === adminPath("recover/login")
  );
}
